import { useState } from "react";
import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  UpdateExecutingBranchRequest,
  useRltWorkOrderUpdateExecutingBranchMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { useErrDocumentNotReady } from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import { useListBranchQuery } from "@/services/backend/branch/api/branch";
import { Label } from "@/shared/components/ui/label";
import t from "@/lang/lang";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { InputValidationErrors } from "@/shared/components/errors/input-error-messages";

export function WorkOrderExecutingBranchSelect({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateExecutingBranchRequest>({
    id: workOrder.id,
    executingBranchId: workOrder.executingBranchId,
  });
  const mutation = useRltWorkOrderUpdateExecutingBranchMutation();
  const { error } = useDebouncedMutation(
    request,
    setRequest,
    mutation,
    {
      id: workOrder.id,
      executingBranchId: workOrder.executingBranchId,
    },
    { delay: 0 },
  );

  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();

  const { data: list } = useListBranchQuery({
    company: { active: true, values: [workOrder.companyId] },
  });
  const branches = list?.branches ?? [];

  return (
    <div className="grid gap-1.5">
      <Label>{t("Ausführende Niederlassung")}</Label>
      <Select
        value={request.executingBranchId}
        onValueChange={(executingBranchId) => {
          setRequest({ ...request, executingBranchId });
          resetNotReadyErrorField("executingBranchId");
        }}
        disabled={disabled}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={t("Auswählen...")} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>{t("Niederlassung")}</SelectLabel>
            {branches.map((branch) => (
              <SelectItem key={branch.id} value={branch.id}>
                {branch.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <InputValidationErrors
        error={error || notReadyError}
        field="executingBranchId"
      />
    </div>
  );
}
